import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';

const outflowManyOffersAB: 'a' | 'b' | false = getFeature('outflow-many-offers-ab');

export const outflowManyOffers = {
    enabled: outflowManyOffersAB === 'b',
} as const;

registerExperiment(
    'many-offers-outflow',
    outflowManyOffersAB,
    [
        AnalyticEventNames.MY_TARIFF_OPEN,
        AnalyticEventNames.MY_TARIFF_CANCEL_AUTOPAY,
        AnalyticEventNames.MY_TARIFF_PROLONG_SUB,

        AnalyticEventNames.MY_TARIFF_CANCEL_AUTOPAY_SHOW,
        AnalyticEventNames.MY_TARIFF_CANCEL_AUTOPAY_TRUE,
        AnalyticEventNames.MY_TARIFF_CANCEL_AUTOPAY_SAVE,

        AnalyticEventNames.POLL_OPEN,
        AnalyticEventNames.POLL_SEND,

        AnalyticEventNames.VK_MUSIC_TARIFF_CANCEL_CANCEL,
        AnalyticEventNames.VK_MUSIC_TARIFF_CANCEL_SAVE,
        AnalyticEventNames.VK_MUSIC_TARIFF_CANCEL_VIEW,

        AnalyticEventNames.MY_TARIFF_CANCEL_SALE_SHOW,
        AnalyticEventNames.MY_TARIFF_CANCEL_SALE_GET,
        AnalyticEventNames.MY_TARIFF_CANCEL_SALE_REJECT,

        AnalyticEventNames.CANCEL_SUB_FAMILY,
        AnalyticEventNames.CANCEL_SUB_EMPTY_FAMILY,
        AnalyticEventNames.CANCEL_SUB_EMPTY_FAMILY_CLICK,
        AnalyticEventNames.CANCEL_SUB_FAMILY_CLICK,
        AnalyticEventNames.CANCEL_SUB_FAMILY_CANCEL,

        AnalyticEventNames.AUTOUPLOAD_CANCEL_SHOW,
        AnalyticEventNames.AUTOUPLOAD_CANCEL_SAVE,
        AnalyticEventNames.AUTOUPLOAD_CANCEL,

        AnalyticEventNames.PAUSE_SUBS_SHOW,
        AnalyticEventNames.PAUSE_SUBS_CLICK,
        AnalyticEventNames.PAUSE_SUBS_CANCEL,

        AnalyticEventNames.CANCEL_SUB_CAPTCHA,
        AnalyticEventNames.CANCEL_SUB_CAPTCHA_CANCEL,
    ],
    {
        mapEventNames: {
            MY_TARIFF_OPEN: 'subs-open',
            MY_TARIFF_CANCEL_AUTOPAY: 'subs-cancel',
            MY_TARIFF_PROLONG_SUB: 'subs-prolong',

            MY_TARIFF_CANCEL_AUTOPAY_SHOW: 'ausure-show',
            MY_TARIFF_CANCEL_AUTOPAY_TRUE: 'ausure-cancel',
            MY_TARIFF_CANCEL_AUTOPAY_SAVE: 'ausure-save',

            VK_MUSIC_TARIFF_CANCEL_CANCEL: 'vkmusic-cancel',
            VK_MUSIC_TARIFF_CANCEL_SAVE: 'vkmusic-save',
            VK_MUSIC_TARIFF_CANCEL_VIEW: 'vkmusic-view',

            MY_TARIFF_CANCEL_SALE_SHOW: 'discount-show',
            MY_TARIFF_CANCEL_SALE_GET: 'discount-get',
            MY_TARIFF_CANCEL_SALE_REJECT: 'discount-reject',

            CANCEL_SUB_FAMILY: 'family-show',
            CANCEL_SUB_EMPTY_FAMILY: 'empty-family-show',
            CANCEL_SUB_EMPTY_FAMILY_CLICK: 'empty-family-click',
            CANCEL_SUB_FAMILY_CLICK: 'family-click',
            CANCEL_SUB_FAMILY_CANCEL: 'family-cancel',

            AUTOUPLOAD_CANCEL_SHOW: 'baz-show',
            AUTOUPLOAD_CANCEL_SAVE: 'baz-save',
            AUTOUPLOAD_CANCEL: 'baz-cancel',

            PAUSE_SUBS_SHOW: 'pause-show',
            PAUSE_SUBS_CANCEL: 'pause-cancel',
            PAUSE_SUBS_CLICK: 'pause-click',

            CANCEL_SUB_CAPTCHA: 'capcha-view',
            CANCEL_SUB_CAPTCHA_CANCEL: 'capcha-cancel',
        },
    }
);
